const initialState = {
    message: '',
    type: '',
};

export default initialState;
